import type { FlipRisk } from "../types/api";

interface Props {
  risk: FlipRisk;
}

function formatPrice(n: number): string {
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
}

export function FlipRiskPanel({ risk }: Props) {
  const priorDate = new Date(risk.prior_sale_date).toLocaleDateString("en-US");
  return (
    <section className={`flip-risk-panel risk-band-${risk.risk_band}`}>
      <h2>Flip Risk: {risk.risk_band_label}</h2>

      <dl className="flip-risk-facts">
        <div>
          <dt>Prior sale</dt>
          <dd>
            {formatPrice(risk.prior_sale_price)} on {priorDate}
          </dd>
        </div>
        <div>
          <dt>Markup</dt>
          <dd>{risk.markup_pct.toFixed(0)}%</dd>
        </div>
        <div>
          <dt>Holding period</dt>
          <dd>{risk.holding_period_years.toFixed(2)} years</dd>
        </div>
        <div>
          <dt>Permits filed during hold</dt>
          <dd>{risk.permits_during_hold.length}</dd>
        </div>
      </dl>

      <h3>Inspector priorities</h3>
      <ul className="inspector-priorities">
        {risk.inspector_priorities.map((p, i) => (
          <li key={i}>{p}</li>
        ))}
      </ul>

      <h3>Suggested offer language</h3>
      <p className="offer-language">{risk.offer_language}</p>
    </section>
  );
}
